module.exports = __webpack_public_path__ + "img/unlock-alt.647cdfe6.svg";